/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Why a file was refused. The unit of limit and actual depends on the reason: FILE_TOO_LARGE in bytes, IMAGE_TOO_LARGE in pixels along the longer side, VIDEO_TOO_LONG in whole seconds, VIDEO_RESOLUTION_TOO_HIGH in pixels along the shorter side (which is what 720p counts). UNSUPPORTED_TYPE covers anything that is not JPEG, PNG, WebP or MP4, HEIC photos and QuickTime films included; UNREADABLE a file that claims to be one of them but is cut short or damaged; VIDEO_CODEC_UNSUPPORTED a picture that is not H.264 in a profile browsers play, or sound that is not AAC; VIDEO_NOT_FASTSTART a film whose index sits after the picture, which makes a browser download all of it before playing.
 * @export
 * @enum {string}
 */

export const MediaRejectionReasonDto = {
    UnsupportedType: 'UNSUPPORTED_TYPE',
    Unreadable: 'UNREADABLE',
    FileTooLarge: 'FILE_TOO_LARGE',
    ImageTooLarge: 'IMAGE_TOO_LARGE',
    VideoTooLong: 'VIDEO_TOO_LONG',
    VideoResolutionTooHigh: 'VIDEO_RESOLUTION_TOO_HIGH',
    VideoCodecUnsupported: 'VIDEO_CODEC_UNSUPPORTED',
    VideoNotFaststart: 'VIDEO_NOT_FASTSTART'
} as const;

export type MediaRejectionReasonDto = typeof MediaRejectionReasonDto[keyof typeof MediaRejectionReasonDto];



